import { useQuery } from '@tanstack/react-query';
import { alarmApi } from '../../services/api';

export const alarmKeys = {
  all: ['alarms'] as const,
  list: (orgId: string, status?: string, severity?: string) =>
    ['alarms', 'list', orgId, status, severity] as const,
  active: (orgId: string) => ['alarms', 'active', orgId] as const,
};

export function useAlarms(orgId?: string, status?: string, severity?: string) {
  return useQuery({
    queryKey: alarmKeys.list(orgId!, status, severity),
    queryFn: () => alarmApi.getAlarms(orgId!, status, severity),
    enabled: !!orgId,
    staleTime: 15_000,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}

export function useActiveAlarms(orgId?: string) {
  return useQuery({
    queryKey: alarmKeys.active(orgId!),
    queryFn: () => alarmApi.getActiveAlarms(orgId!),
    enabled: !!orgId,
    staleTime: 15_000,
    refetchInterval: 30_000,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}
